module.exports = __webpack_public_path__ + "img/burner-inserter-platform.aeef3a3c.png";